import { useTranslation } from "react-i18next";
import { Category } from "@/types/globalTypes";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CashierCardsList from "./CashierCardsList";
import { RootState } from "@/store/store";
import { CashierMenuType } from "@/types/CashierProductType";
import { useSidebar } from "@/contexts/SidebarContext";
interface CashierNavBarProps {
    setTaxesActive: (value: boolean) => void
    isTables?: boolean
}

export default function CashierNavBar({ setTaxesActive, isTables }: CashierNavBarProps) {
  const { t } = useTranslation();
    const branch = useSelector((state: RootState) => state.branch.branch);
    const baseUrl = import.meta.env.VITE_BASE_URL
    const token = useSelector((state: { auth: { token: string } }) => state.auth.token);
    const [categories, setCategories] = useState<Category[]>();
    const [selectedCategory, setSelectedCategory] = useState<string>("")
    const [CashierItems, setCashierItems] = useState<CashierMenuType[]>([])
    const [isLoading, setIsLoading] = useState(false);
      const {isShowingIconsOnly} = useSidebar()



    async function getCategories() {
        try {
            const options = {
                url: `${baseUrl}/api/dashboard/menu`,
                method: "GET",
                headers: {
                    Authorization: token,
                },
            }
            const response = await axios.request(options);
            setCategories(response.data.menu)

        } catch (error) {
            console.error(error);
        }
    }
    async function getItems() {
        setIsLoading(true)
        try {
            const options = {
                url: `${baseUrl}/api/dashboard/menu?branch=${branch?._id}&category=${selectedCategory}`,
                method: "GET",
                headers: {
                    Authorization: token,
                },
            }
            const response = await axios.request(options);
            if (response.data.success == true) {
                setCashierItems(response.data.menu)
                setTaxesActive(response.data.taxActivated)
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setIsLoading(false)
        }
    }
    useEffect(() => {
        getCategories()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        getItems()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCategory, branch])
    return (
        <>
            <div className={`col-span-4 ${isShowingIconsOnly ? "lg:col-span-11" : "lg:col-span-8"} ${isShowingIconsOnly ? "break2lg-col-span-12" : "break2lg-col-span-11"} 2xl:col-span-8 `}>
                <div className="flex items-center gap-2 w-full overflow-x-auto thin-scrollbar text-nowrap pb-1">
                    <button onClick={() => setSelectedCategory("")} className={` border-2 font-semibold  ${selectedCategory === "" ? "bg-sidebar text-skyblue" : "bg-skyblue text-sidebar"} w-fit px-5 py-2 rounded-md`}> {t("cashierNavbar.all")} </button>
                    {categories?.map((category) => (
                        <button onClick={() => setSelectedCategory(category._id)} key={category._id} className={` border-2 ${selectedCategory === category._id ? "bg-sidebar text-skyblue" : "bg-skyblue text-sidebar"} font-semibold   w-fit px-5 py-2 rounded-md`}> {t(category.nameEN, category.nameAR)} </button>
                    ))}
                </div>
                <div className={`col-span-4 ${isShowingIconsOnly ? "lg:col-span-11" : "lg:col-span-8"} ${isShowingIconsOnly ? "break2lg-col-span-12" : "break2lg-col-span-11"}  2xl:col-span-8 bg-gray-300 h-1 my-3`}></div>

                <CashierCardsList CashierMenuItems={CashierItems} isLoading={isLoading} isTables={isTables} />
            </div>

        </>
    )
}

